<template>
	<b-modal :no-close-on-backdrop="true" :hide-header-close="isLoading" ref="modal" title="Uvoz lokacije 4" :size="modalSize" class="modal-primary" @hidden="clearModalData">
		<CRow v-if="updateSuccess !== true">
			<CCol>
				<b-form-file
					v-model="spOrderLocation4UploadFile"
					:placeholder="uploadPlaceholder"
					drop-placeholder="Povleci datoteko..."
					browse-text="Brskaj"
					@input="uploadSpOrderLocation4File"
					accept=".xls, .xlsx"/>
			</CCol>
		</CRow>
		<CRow v-if="updateSuccess">
			<CCol>
				<b-card>
					<CRow>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število ustvarjenih</CCardHeader>
								<CCardBody><span class="display-3">{{ numCreatedItems }}</span></CCardBody>
							</CCard>
						</CCol>
						<CCol  class="text-center">
							<CCard color="primary" class="text-center" body-wrapper text-color="white">
								<CCardHeader class="numberCardHeader">Število posodobljenih</CCardHeader>
								<CCardBody><span class="display-3">{{ numUpdatedItems }}</span></CCardBody>
							</CCard>
						</CCol>
					</CRow>
				</b-card>
				<CRow v-if="spOrderLocation4MishatchedLocationTableProps.items.length > 0">
					<CCol>
						<b-card>
							<div slot="header">
								<b>Nadomestni deli z različno lokacijo</b>
							</div>
							<b-table
								ref="spOrderItemsUpdatedStatus"
								responsive="sm"
								striped
								show-empty
								hover
								:empty-text="spOrderLocation4MishatchedLocationTableProps.empty_text"
								:empty-filtered-text="spOrderLocation4MishatchedLocationTableProps.empty_filtered_text"
								:fields="spOrderLocation4MishatchedLocationTableProps.fields"
								:current-page="spOrderLocation4MishatchedLocationTableProps.currentPage"
								:per-page="spOrderLocation4MishatchedLocationTableProps.itemsPerPage"
								:items="spOrderLocation4MishatchedLocationTableProps.items">
								<template v-slot:cell(stock)="data">
									{{ data.item.stock_quantity }}
								</template>
								<template v-slot:cell(excelStock)="data">
									{{ data.item.itemInExcel.stock_quantity }}
								</template>
								<template v-slot:cell(created_at)="data">
									{{ data.item.created_at | viewDate }}
								</template>
								<template v-slot:cell(main_location)="data">
									<CButton class="text-wrap m-0 p-1" color="info" @click.stop="spOrderLocation4UpdateLocation(data.item, 'db')" size="sm">{{ data.item.main_location }}</CButton>
								</template>
								<template v-slot:cell(excelLocation)="data">
									<CButton class="text-wrap m-0 p-1" color="info" @click.stop="spOrderLocation4UpdateLocation(data.item, 'excel')" size="sm">{{ data.item.itemInExcel.main_location }}</CButton>
								</template>
								<template v-slot:cell(actions)="data">
									<CButton color="warning" @click.stop="spOrderLocation4UpdateLocation(data.item, 'none')" size="sm"><CIcon name="cil-x"/></CButton>
									<CButton class="ml-1" color="danger" @click.stop="click_spOrdersLocation4Delete(data.item)" size="sm"><CIcon name="cil-trash"/></CButton>
								</template>
							</b-table>
						</b-card>
					</CCol>
				</CRow>
			</CCol>
		</CRow>
		<CAlert v-show="message.text != null" :color="message.type">
			{{ message.text }}
		</CAlert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button v-if="updateSuccess !== true" :disabled="isLoading" style="margin-right:5px;" variant="secondary" @click="onCancelModal()">Prekliči</b-button>
						<b-button :disabled="okButtonDisabled" variant="primary" @click.stop="onOkModal()">{{ okButton.label }}</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
		<vue-loading :active.sync="isLoading" :is-full-page="false"/>
	</b-modal>
</template>

<script>
import settings from '@/settings.js';
const PH_TEXT = 'Izberi ali povleci datoteko ...';
import {
	SP_ORDERS_LOCATION4_CREATE,
	SP_ORDERS_LOCATION4_IMPORT,
	SP_ORDERS_LOCATION4_DELETE
} from "@/store/actions/spOrdersLocation4";

export default {
	name: 'sp-order-items-status-update-from-file-modal',
	components: {
	},
	props: {
	},
	methods: {
		showModal: function () {
			this.$refs.modal.show();
		},
		onOkModal: function () {
			if (this.updateSuccess === true) {
				this.$refs.modal.hide();
				this.clearModalData();
			} else {
				this.startProgress();
				this.uploadFile(this, this.spOrderLocation4UploadFile);
			}
		},
		onCancelModal: function () {
			this.$refs.modal.hide();
		},
		clearModalData: function () {
			this.isLoading = false;
			this.title = '';
			this.okButton = {
				label: 'Posodobi',
				progress: false,
				disabled: true
			};
			this.showAlert();
			this.spOrderLocation4MishatchedLocationTableProps.items = [];
			this.numCreatedItems = 0;
			this.numUpdatedItems = 0;
			this.totalProcessed = 0;
			this.spOrderLocation4UploadFile = null;
			if (this.updateSuccess) this.$emit('emit_spOrderLocation4ImportSuccess');
			this.updateSuccess = null;
		},
		startProgress: function () {
			this.isLoading = true;
			this.okButton.disabled = true;
			this.okButton.progress = true;
		},
		stopProgress: function () {
			this.isLoading = false;
			this.okButton.disabled = false;
			this.okButton.progress = false;
		},
		showAlert: function (message, type, seconds) {
			if (message && type && seconds) {
				this.message.type = type;
				this.message.text = message;
				setTimeout(() => {
					this.showAlert();
				}, seconds * 1000);
			} else if (message && type) {
				this.message.type = type;
				this.message.text = message;
			} else if (message) {
				this.message.type = 'primary';
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		uploadSpOrderLocation4File: function () {
			if (this.spOrderLocation4UploadFile.size > 10485760) {
				this.showError('Datoteka ' + attachment.name + ' je prevelika!')
			}
		},
		uploadFile: function (ctx, file) {
			const formData = new FormData();
			formData.append('file', file);
			this.startProgress();
			this.$store.dispatch(SP_ORDERS_LOCATION4_IMPORT, formData)
				.then((responseData) => {
					this.stopProgress();
					this.numCreatedItems = responseData.statistics.created;
					this.numUpdatedItems = responseData.statistics.updated;
					this.totalProcessed = responseData.statistics.total_processed;
					this.spOrderLocation4MishatchedLocationTableProps.items = responseData.missmathchedLocationItems;
					this.updateSuccess = true;
					this.okButton.label = 'Končaj';
				})
				.catch(error => {
					this.stopProgress();
					this.updateSuccess = false;
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri uvozu datoteke! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		spOrderLocation4UpdateLocation: function (item, locationFrom) {
			if (locationFrom === 'none') {
				this.spOrderLocation4MishatchedLocationTableProps.items = this.spOrderLocation4MishatchedLocationTableProps.items.filter(filterItem => filterItem.id !== item.id);
				return;
			}
			let itemInExcel = item.itemInExcel;
			itemInExcel.id = item.id;
			if (locationFrom === 'db') itemInExcel.main_location = item.main_location;
			this.startProgress();
			this.$store.dispatch(SP_ORDERS_LOCATION4_CREATE, { item: itemInExcel })
				.then((responseData) => {
					this.numUpdatedItems++;
					this.spOrderLocation4MishatchedLocationTableProps.items = this.spOrderLocation4MishatchedLocationTableProps.items.filter(filterItem => filterItem.id !== item.id);
					this.stopProgress();
				})
				.catch(error => {
					this.stopProgress();
					console.error(error);
					if(error.response && error.response.data && error.response.data.code) {
						this.showAlert('Napaka pri shranjevanju lokacije! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
					} else {
						this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
					}
				});
		},
		click_spOrdersLocation4Delete: function (data) {
			this.$bvModal.msgBoxConfirm('Želite izbrisati vnos lokacije 4 #' + data.id + '?', {
				title: 'Potrdite brisanje vnosa lokacije 4',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'DA',
				cancelTitle: 'NE',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(value => {
				if (value === true) {
					this.startProgress();
					this.$store.dispatch(SP_ORDERS_LOCATION4_DELETE, { id: data.id })
						.then((responseData) => {
							this.stopProgress();
							this.spOrderLocation4MishatchedLocationTableProps.items = this.spOrderLocation4MishatchedLocationTableProps.items.filter(filterItem => filterItem.id !== data.id);
						})
						.catch(error => {
							this.stopProgress();
							console.error(error);
							if(error.response && error.response.data && error.response.data.code) {
								this.showAlert('Napaka pri shranjevanju lokacije! (' + error.response.data.code + ')', this.ALERT_TYPE_ERROR);
							} else {
								this.showAlert('Napaka! Prosimo poizkusite kasneje.', this.ALERT_TYPE_ERROR);
							}
						});
				}
			}).catch(err => {
				console.error(err);
			})
		},
	},
	data: function () {
		return {
			settings,
			isLoading: false,
			title: '',
			okButton: {
				label: 'Posodobi',
				progress: false,
				disabled: true
			},
			message: {
				type: null,
				text: null
			},
			ALERT_TYPE_SUCCESS: 'success',
			ALERT_TYPE_ERROR: 'danger',
			spOrderLocation4UploadFile: null,
			spOrderLocation4MishatchedLocationTableProps: {
				fields: [
					{ key: 'part_number', label: 'Kataloška št.', class: 'tdCatalogNumber' },
					{ key: 'description', label: 'Description' },
					{ key: 'note', label: 'Opomba', class: 'tdNote' },
					{ key: 'stock', label: 'Količina v bazi', class: 'tdNote' },
					{ key: 'excelStock', label: 'Količina v excelu', class: 'tdNote' },
					{ key: 'main_location', label: 'Lokacija v bazi', class: 'tdLocation' },
					{ key: 'excelLocation', label: 'Lokacija v excelu', class: 'tdLocation' },
					{ key: 'created_at', label: 'Ustvarjen', class: '' },
					{ key: 'actions', label: '#', class: 'tdActions' },
				],
				items: []
			},
			numCreatedItems: 0,
			numUpdatedItems: 0,
			totalProcessed: 0,
			updateSuccess: null
		}
	},
	watch: {
	},
	computed: {
		modalSize () {
			if (this.updateSuccess > 0) return 'xl';
			return 'md';
		},
		uploadPlaceholder () {
			return PH_TEXT;
		},
		okButtonDisabled () {
			if (this.okButton.disabled && !this.spOrderLocation4UploadFile) {
				return true;
			}
			return false;
		}
	},
	created () {
	}
}
</script>

<style scoped>
.ma_pos {
	text-align: end;
}
.numberCardHeader {
	min-height: 5.5rem;
}
</style>
<style>
.tdCatalogNumber {
	width: 10rem;
	min-width: 10rem;
	text-align: center;
}
.tdNote {
	width: 5rem;
	min-width: 5rem;
	text-align: center;
}
.tdLocation {
	width: 9rem;
	min-width: 9rem;
	text-align: center;
}
.tdActions {
	width: 7rem;
	min-width: 7rem;
	max-width: 7rem;
	text-align: center;
}
</style>